import apiRequestService from '@/commonProject/service/apiRequestService';

export default class fileUploadRepository {
    /**
     * アップロード履歴取得APIをコールする。
     * @param {Object} queryParam
     * @returns result
     */
    async getFileUploadActionApi(API_URL, queryParam, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/uldhst', queryParam, idToken);
        return result;
    }

    /**
     * アップロード履歴更新APIをコールする。
     * @param {Object} requestBody
     * @returns result
     */
    async putFileUploadActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPut(API_URL + '/uldhst', requestBody, idToken);
        return result;
    }
}
